import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"

export default class extends Controller {
  static values = { id: Number }

  connect() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch the insights of the campaigns
    if (NavigationHelper.pageIsPreview()) { return }

    this.load()
  }

  load() {
    let _this = this

    // When the frame is loaded
    document.getElementById(`campaign-insights-${this.idValue}`).loaded.then(function () {
      App.tooltip(_this.element.querySelectorAll("[data-bs-toggle='tooltip']"))
    })
  }
}
